var _style, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5C993E;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.34,21.1H3.66c-1.45,0-2.63-1.18-2.63-2.63V6.53c0-1.45,1.18-2.63,2.63-2.63h17.68 c1.45,0,2.63,1.18,2.63,2.63v11.94C23.96,19.92,22.79,21.1,21.34,21.1z M3.66,5.33C3,5.33,2.47,5.87,2.47,6.53v11.94 c0,0.66,0.54,1.19,1.19,1.19h17.68c0.66,0,1.19-0.54,1.19-1.19V6.53c0-0.66-0.54-1.19-1.19-1.19H3.66z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,12.5c-1.32,0-2.39-1.07-2.39-2.39c0-1.32,1.07-2.39,2.39-2.39s2.39,1.07,2.39,2.39 C10.59,11.43,9.52,12.5,8.2,12.5z M8.2,9.16c-0.53,0-0.96,0.43-0.96,0.96c0,0.53,0.43,0.96,0.96,0.96s0.96-0.43,0.96-0.96 C9.16,9.58,8.73,9.16,8.2,9.16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.78,17.28c-0.4,0-0.72-0.32-0.72-0.72v-0.48c0-0.66-0.54-1.19-1.19-1.19H6.53c-0.66,0-1.19,0.54-1.19,1.19 v0.48c0,0.4-0.32,0.72-0.72,0.72c-0.4,0-0.72-0.32-0.72-0.72v-0.48c0-1.45,1.18-2.63,2.63-2.63h3.34c1.45,0,2.63,1.18,2.63,2.63 v0.48C12.5,16.96,12.18,17.28,11.78,17.28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.38,9.63h-5.25c-0.4,0-0.72-0.32-0.72-0.72c0-0.4,0.32-0.72,0.72-0.72h5.25c0.4,0,0.72,0.32,0.72,0.72 C21.1,9.31,20.78,9.63,20.38,9.63z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.38,13.46h-5.25c-0.4,0-0.72-0.32-0.72-0.72s0.32-0.72,0.72-0.72h5.25c0.4,0,0.72,0.32,0.72,0.72 S20.78,13.46,20.38,13.46z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.38,17.28h-5.25c-0.4,0-0.72-0.32-0.72-0.72s0.32-0.72,0.72-0.72h5.25c0.4,0,0.72,0.32,0.72,0.72 S20.78,17.28,20.38,17.28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.772766ca121979662afbb225a5d2624b.svg";
export { ForwardRef as ReactComponent };